"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ScenarioSharing;
(function (ScenarioSharing) {
    ScenarioSharing["private"] = "private";
    ScenarioSharing["public"] = "public";
})(ScenarioSharing = exports.ScenarioSharing || (exports.ScenarioSharing = {}));
//# sourceMappingURL=ScenarioSharing.js.map